import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "group-title"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "text-muted" }

import ElCardHeader from "~/cabinet/vue/interface/card/ElCardHeader.vue";
import ElCardSection from "~/cabinet/vue/interface/card/ElCardSection.vue";
import {
    TreeSelectorGroupInterface,
    TreeSelectorItemInterface
} from "~/cabinet/vue/interface/treeSelectorDialog/Interface";
import {computed, nextTick, onMounted, ref} from "vue";
import CascaderHelper, {CascadeOptionWithDescrArray, CascaderOptionInterface} from "~/core-ui/ts/CascaderHelper";
import Dictionary from "~/ts/library/Dictionary";
import ObjectHelper from "~/ts/library/ObjectHelper";
import Delay from "~/ts/library/Delay";
import {requiredRule} from "~/core-ui/ts/CoreUiHelpersMixin";


const __default__ = {
    name: "TreeSelectorDialog"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    groups: {},
    items: {},
    notFoundMessage: {},
    categoryColumnHeader: {}
  }, {
    "visible": { type: Boolean },
    "visibleModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["select"], ["update:visible"]),
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let tree = ref<{
    setCurrentKey: (key?: string) => void
}>();

let groupsDictionary = computed(() => ObjectHelper.dictionaryFromArray(props.groups, "id"));

let visible = _useModel<boolean>(__props, "visible");
let searchInput = ref<HTMLTextAreaElement>();
let searchQuery = ref<string>();

let currentTreeNode = ref<CascadeOptionWithDescrArray>();

let cascaderOptions = computed(() => {
    let cascaderItems: CascaderOptionInterface[] = [];
    for (let group of props.groups) {
        if (!findChildGroup(group)) {
            cascaderItems.push({
                id: group.id,
                descr: group.descrArray
            });
        }
    }
    return CascaderHelper.createOptions(cascaderItems);
});

function findChildGroup(group: TreeSelectorGroupInterface): TreeSelectorGroupInterface {
    for (let item of props.groups) {
        if (item.descrArray.length > group.descrArray.length) {
            let good = true;
            for (let i = 0; i < group.descrArray.length; i++) {
                if (item.descrArray[i] !== group.descrArray[i]) {
                    good = false;
                    break;
                }
            }
            if (good) {
                return item;
            }
        }
    }
    return null;
}

function onCurrentTreeNodeChange(value: any) {
    if (currentTreeNode.value === value) {
        resetCurrentTreeNode();
        value = null;
    }
    if (value) {
        searchQuery.value = null;
    }
    currentTreeNode.value = value;
}

function resetCurrentTreeNode() {
    currentTreeNode.value = null;
    nextTick(() => {
        tree.value?.setCurrentKey(null);
    });
}

function fillGroupIndexList(result: string[], groups: CascadeOptionWithDescrArray[]) {
    for (let group of groups) {
        result.push(group.descrArray.join("/"));
        if (group.children) {
            fillGroupIndexList(result, group.children);
        }
    }
}

let groupIndexList = computed(() => {
    let groupDescrList: string[] = [];
    fillGroupIndexList(groupDescrList, cascaderOptions.value);
    let result: Dictionary<number> = {};
    for (let group of props.groups) {
        result[group.id] = groupDescrList.indexOf(group.descrArray.join("/"));
    }
    return result;
});

let itemsToDisplay = computed(() => {
    let items = props.items;
    let level = 0;
    if (searchQuery.value?.trim().length > 1) {
        let searchQueryLowerCase = searchQuery.value.trim().toLocaleLowerCase();
        items = items.filter(filter => {
            let groupDescr = groupsDictionary.value[filter.group]?.descrArray ?? [];
            return (filter.descr + " " + groupDescr.join(" ")).toLocaleLowerCase().includes(searchQueryLowerCase);
        })
    } else if (currentTreeNode.value) {
        level = currentTreeNode.value.descrArray.length;
        let descrArray = currentTreeNode.value.descrArray;
        items = items.filter(filter => {
            let groupId = filter.group;
            if (groupId) {
                let group = groupsDictionary.value[groupId];
                if (group) {
                    for (let i = 0; i < descrArray.length; i++) {
                        if (group.descrArray[i] !== descrArray[i]) {
                            return false;
                        }
                    }
                    return true;
                }
            }
            return false;
        });
    }

    if (items.length == 0 && currentTreeNode.value) {
        setTimeout(() => {
            resetCurrentTreeNode();
        }, 50);
    }

    let result: Dictionary<{ groupId: string, groupDescr: string, items: TreeSelectorItemInterface[] }> = {};
    for (let item of items) {
        if (!result[item.group]) {
            let groupDescr = groupsDictionary.value[item.group]?.descrArray.slice(level) ?? [];
            if (!groupDescr.length && currentTreeNode.value) {
                groupDescr = currentTreeNode.value.descrArray.slice(level - 1);
            }
            result[item.group] = {
                groupId: item.group,
                items: [],
                groupDescr: groupDescr.join(" / ")
            };
        }
        result[item.group].items.push(item);
    }
    return ObjectHelper.arrayFromDictionary(result).sort((a, b) => groupIndexList.value[a.groupId] < groupIndexList.value[b.groupId] ? -1 : 1);
});

function selectItem(item: TreeSelectorItemInterface) {
    emits("select", item.id);
    visible.value = false;
}

onMounted(async () => {
    await Delay.make(10);
    searchInput.value?.focus();
});



return (_ctx: any,_cache: any) => {
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_on_native = _resolveDirective("on-native")!

  return (_unref(visible))
    ? (_openBlock(), _createBlock(_component_el_dialog, {
        key: 0,
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(visible) ? (visible).value = $event : visible = $event)),
        title: "Выбор",
        width: __props.groups.length > 1 ? '900px' : '650px',
        "close-on-click-modal": "",
        "close-on-press-escape": "",
        class: "transparent"
      }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_el_row, { gutter: 20 }, {
            default: _withCtx(() => [
              (__props.groups.length > 1)
                ? (_openBlock(), _createBlock(_component_el_col, {
                    key: 0,
                    xs: 0,
                    span: 9
                  }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_el_card, {
                        class: "overflow-hidden",
                        shadow: "never"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(ElCardHeader, { title: __props.categoryColumnHeader }, null, 8, ["title"]),
                          _createVNode(ElCardSection, { padding: false }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_tree, {
                                    ref_key: "tree",
                                    ref: tree,
                                    class: "group-tree",
                                    accordion: "",
                                    "check-on-click-node": "",
                                    "node-key": "descrArrayMd5",
                                    "current-node-key": _unref(currentTreeNode) ? _unref(currentTreeNode).descrArrayMd5 : undefined,
                                    "auto-expand-parent": "",
                                    "default-expanded-keys": _unref(currentTreeNode) ? [_unref(currentTreeNode).descrArrayMd5] : [],
                                    "highlight-current": "",
                                    data: _unref(cascaderOptions),
                                    onCurrentChange: onCurrentTreeNodeChange
                                  }, null, 8, ["current-node-key", "default-expanded-keys", "data"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [
                          _directive_on_native,
                          void 0,
                          "click",
                          { stop: true }
                        ]
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_col, {
                span: 24,
                md: __props.groups.length > 1 ? 15 : 24
              }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_el_card, {
                    class: "overflow-hidden",
                    shadow: "never"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ElCardSection, { padding: false }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form, {
                            style: {"padding":"0 !important","margin":"0 !important"},
                            rules: {}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                rules: {},
                                style: {"padding":"0 !important","margin":"0 !important"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _unref(searchQuery),
                                    "onUpdate:modelValue": [
                                      _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchQuery) ? (searchQuery).value = $event : searchQuery = $event)),
                                      _cache[1] || (_cache[1] = ($event: any) => (resetCurrentTreeNode()))
                                    ],
                                    ref_key: "searchInput",
                                    ref: searchInput,
                                    class: "search-input",
                                    placeholder: "Поиск..."
                                  }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(itemsToDisplay), (group) => {
                        return (_openBlock(), _createBlock(ElCardSection, {
                          key: group.groupId,
                          padding: false
                        }, {
                          default: _withCtx(() => [
                            (group.groupDescr.length)
                              ? (_openBlock(), _createElementBlock("h5", _hoisted_1, _toDisplayString(group.groupDescr), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: item.id,
                                  class: "filter-select",
                                  onClick: ($event: any) => (selectItem(item))
                                }, _toDisplayString(item.descr), 9, _hoisted_2))
                              }), 128))
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128)),
                      (!_unref(itemsToDisplay).length)
                        ? (_openBlock(), _createBlock(ElCardSection, { key: 0 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_3, _toDisplayString(__props.notFoundMessage), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })), [
                    [
                      _directive_on_native,
                      void 0,
                      "click",
                      { stop: true }
                    ]
                  ])
                ]),
                _: 1
              }, 8, ["md"])
            ]),
            _: 1
          })), [
            [_directive_on_native, () => {_isRef(visible) //@ts-ignore
 ? visible.value = false : visible = false;}, "click"]
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "width"]))
    : _createCommentVNode("", true)
}
}

})